import { takeLatest, put } from 'redux-saga/effects';
import {
  getCountryListSuccess, getCountryListFail,
  getEmployeeListSuccess, getEmployeeListFail,
  getLeaveTypeListSuccess, getLeaveTypeListFail,
  getDepartmentListSuccess, getDepartmentListFail,
  getLeaveStateListSuccess,
} from './optionlistState';
import createCrudService from '../../services/crudservice';
import { doCrudCall } from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/console/options');

function* getCountryList(data) {
	yield doCrudCall(
		() => crudService.doGetRequest('country-list',data.payload), 
		getCountryListSuccess, 
		getCountryListFail);
}

function* getEmployeeList(data) {
	yield doCrudCall(
		() => crudService.doGetRequest('employee-list',data.payload), 
		getEmployeeListSuccess, 
		getEmployeeListFail);
}

function* getLeaveTypeList(data) {
	yield doCrudCall(
		() => crudService.doGetRequest('leave-type-list',data.payload), 
		getLeaveTypeListSuccess, 
		getLeaveTypeListFail);
}

function* getDepartmentList(data) {
	yield doCrudCall(
		() => crudService.doGetRequest('department-list',data.payload), 
		getDepartmentListSuccess, 
		getDepartmentListFail);
}

function* getLeaveStateList() {
  yield put(getLeaveStateListSuccess());
}

function* optionlistSaga() {
  yield takeLatest('optionlist/getCountryList', getCountryList);
  yield takeLatest('optionlist/getEmployeeList', getEmployeeList);
  yield takeLatest('optionlist/getLeaveTypeList', getLeaveTypeList);
  yield takeLatest('optionlist/getDepartmentList', getDepartmentList);
  yield takeLatest('optionlist/getLeaveStateList', getLeaveStateList);
}

export default optionlistSaga;
